var myAccordion = new gianniAccordion({
  elements: ".accordion .accordion-inner",
          trigger: "[data-accordion-element-trigger]",
          content: "[data-accordion-element-content]",
});
